<div class="dialog-container-main right-side-popup">
    <div class="dialog-header">
      <!-- Compose message   -->
        <h2 mat-dialog-title >
        </h2><button mat-button mat-dialog-close><span class="material-icons">close</span></button>
    </div>

    <div class="right-side-content">
        <form [formGroup]="applicationForm" >
            <mat-dialog-content class="mat-typography notification-popup">
                <div class="dialog-form-box">
                    <div class="box-labelsuper ">
                        <h4 >Send Message</h4>
                    </div>
                    <!-- <div class="field-group ">
                        <mat-label>To</mat-label>
                        <mat-form-field appearance="outline" class="custom-form-field">
                            <input matInput placeholder="To" >
                        </mat-form-field>
                    </div> -->
                    <div class="field-group ">
                        <mat-label>Subject</mat-label>
                        <mat-form-field appearance="outline" class="custom-form-field">
                            <input matInput placeholder="Enter subject" formControlName="subject">
                        </mat-form-field>
                    </div>
                    <div class="field-group ">
                        <!-- <mat-label>Description</mat-label> -->
                        <mat-form-field appearance="outline" class="custom-form-field textarea100">
                            <textarea class="textarea-content" rows="10" matInput placeholder="Compose Message" formControlName="description"></textarea>
                        </mat-form-field>
                    </div>
    
                    <mat-divider class="divider"></mat-divider>
    
    
                    <!-- <mat-dialog-actions class="btn-col-footer">
                        <button mat-button color="primary" mat-dialog-close class="popup-btn">Cancel</button>
                        <button mat-flat-button cdkFocusInitial class="green popup-btn" (click)="onSubmit()">
                            Send 
                        </button>
                    </mat-dialog-actions> -->
    
                </div>
    
            </mat-dialog-content>
            
        </form>
        
    </div>
    <div class="right-popup-bottom">
        <button mat-button color="primary" class="cancel-btn" mat-dialog-close>Cancel</button>
        <div class="attach-send-btn">
          <button mat-icon-button class="attach-btn" ><mat-icon> attach_file</mat-icon></button>

          <button mat-button  class="send-btn" (click)="onSubmit()"  >
              Send
            </button>
      </div>
      </div>

</div>